jQuery(function ($) {
  'use strict';

  /**
   * Youtube Video Background-play
   * https://github.com/pupunzi/jquery.mb.YTPlayer
   *
   */
  var youtubeVideoElId = "[id^=\"ytPlayer\"]";
  if ($(youtubeVideoElId).length > 0) {
    $(youtubeVideoElId).each(function(index, element){
      var myPlayer = $(element).YTPlayer( {
        // onReady: function( player ) {
        //   if($(element).data('gray-filter') === 1) {
        //     myPlayer.YTPApplyFilters({grayscale: 100});
        //   }
        // }
      });
    });
  }

  /**
   * slider settings (Top-page collection-custom-list section)
   * https://kenwheeler.github.io/slick/
   */
  var itemCount = $('.slick--collection-list .flex-item').length >= 4 ? 4 : $('.slick--collection-list .flex-item').length;

  $('.slick--collection-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: itemCount,
    slidesToScroll: itemCount,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  /**
   * Mobile nav-menu open/close
   */
  $('.site-header__menu').on('click', function() {
    $('.mobile-nav-wrapper-custom').toggleClass("is-open");
    $(this).toggleClass("mobile-nav--close");
    $(this).toggleClass("mobile-nav--open");
    $('html').toggleClass("js-drawer-open");
    $('body').toggleClass("js-drawer-open");
  });

  // $('#SearchDrawerMobile .search-form__input-wrapper input').on('focus', function() {
  //   console.log('aaa');
  // });

  /**
   * Mobile nav-menu accordion
   * https://www.jqueryscript.net/accordion/Responsive-Multi-Level-Accordion-Menu-Plugin.html
   */
  $('#mobile-navigation [data-accordion]').accordion({
      transitionSpeed: 400,
      transitionEasing: 'ease',
      controlElement: '[data-control]',
      contentElement: '[data-content]',
      groupElement: '[data-accordion-group]',
      singleOpen: false
  });

  /**
   * Desktop Nav-menu hover
   */
  $("header .site-nav__childlist-item.no-child").hover(
    function () {
      $('header .site-nav__childlist-item.first-item').addClass('like-hover');
    },
    function () {
    }
  );
  $("header .site-nav__childlist-item.not-first-item.has-child").hover(
    function () {
      $('header .site-nav__childlist-item.first-item').removeClass('like-hover');
    },
    function () {
      $('header .site-nav__childlist-item.first-item').addClass('like-hover');
    }
  );

  /**
   * Collection page tag-filter
   */
  var collectionFilterAreaId = '#collection-filter-area';
  if ($(collectionFilterAreaId).length === 1) {
    var $nav   = $(collectionFilterAreaId);
    var $btn   = $('#open-filter-btn');
    var $mask  = $('#mask');
    // menu open close
    $btn.on( 'click', function() {
      if ( ! $nav.hasClass( 'open' ) ) {
        $('.page-container').css({'transform':'none'});
        $('body').css({'overflow':'hidden'});
        $nav.addClass( 'open' );

      } else {
        $('.page-container').css({'transform':''});
        $('body').css({'overflow':'auto'});
        $nav.removeClass( 'open' );

      }
    });
    // mask close
    $mask.on('click', function() {
      $nav.removeClass( 'open' );
      $('body').css({'overflow':'auto'});
    });

    $('.filter-list').on('click', function () {
      if (!$(this).hasClass('is-selected')) {
        $(this).addClass('is-selected');
      } else {
        $(this).removeClass('is-selected');
      }
    });

    function getTags() {
      var tagString = '';
      var tags = [];

      // get filter-list tags
      $('.filter-list.is-selected').each( function(i, el) {
        tags.push($(el).data('tag'));
      });

      // get radio tag
      var radioTag = $('.radio-filter[name="tag"]:checked').val();
      if (radioTag) {
        tags.push(radioTag);
      }

      if (tags.length > 0) {
        tagString = tags.join('+');
      }
      return tagString;
    }

    function redirectWithTags() {
      var tagString = getTags();
      var searchParams = $(location).attr('search');
      var protocol = $(location).attr('protocol');
      var hostname = $(location).attr('hostname');
      var collectionHandle = $(collectionFilterAreaId).data('collection-handle');
      var url = protocol + '//' + hostname + '/collections/' + collectionHandle + '/' + tagString + searchParams;
      window.location.href = url;
    }

    $('#apply-filter-btn,.radio-filter-label').on('click', function () {
      redirectWithTags();
    });

    $('#reset-filter-btn').on('click', function (event) {
      $('.filter-list.is-selected').each(function(i, el){
        $(el).removeClass('is-selected');
      });
    });

    $('.remove-all-filter').on('click', function (event) {
      $('.filter-list.is-selected').each(function(i, el){
        $(el).removeClass('is-selected');
      });
      redirectWithTags();
    });
  }

  /**
   * Collection page mobile dropdown collection-links
   */
  if ($('#CollectionDropdown').length === 1) {
    $('#CollectionDropdown').change(function() {
      var collection_url = $(this).val();
      window.location.href = collection_url;
    });
  }

  /**
   * popup product image in product page
   * https://github.com/dimsemenov/Magnific-Popup
   */
  var productImgPopupWrapperEl = '.product-single__media';
  if ($(productImgPopupWrapperEl).length > 0) {
    $(productImgPopupWrapperEl).magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading ...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      }
    });
  }

  /**
   * Image rotate animation  https://coco-factory.jp/ugokuweb/js02/
   */
  //スクロールをしたら1度だけアニメーションをする設定
  $('.scroll-rotate-animation-odd-trigger').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).addClass('scroll-rotate-animation-odd');
    } /*else {
      $(this).removeClass('scroll-rotate-animation-odd');
    }*/
  });

  $('.scroll-rotate-animation-even-trigger').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).addClass('scroll-rotate-animation-even');
    } /*else {
      $(this).removeClass('scroll-rotate-animation-even');
    }*/
  });

  /**
   * smooth scroll: Sustainable page, About page, PDP-detail
   */
  $('a[href^="#"].smooth-scroll').click(function(){
    $('.smooth-scroll.active').removeClass('active');
    $(this).addClass('active');

    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href === "#" || href === "" ? 'html' : href);

    $('[id^="nav-anchor-"].active').removeClass('active');
    target.addClass('active');
    //console.log(target)
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  /**
   * Product page: product detail
   */
  if ($('.product-detail-section').length > 0) {
    $('.product-detail-item .name.has-description').hover(
       function() {
         var description = $($(this).parent()).find('.description-wrapper');
         description.addClass('show');
       }, function() {
         var description = $($(this).parent()).find('.description-wrapper');
         description.removeClass('show');
       }
     );
  }

  /**
   * Sustainable page slide
   */
  var slideElementClass = '.page-sustainable-wrapper .slide';
  if ($(slideElementClass).length > 0) {
    $(slideElementClass).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      swipe: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
  }

  /**
   * Blog article list page sorting
   */
  $('.template-blog select[name="sort_by"]').on('change', function() {
    var sortBy = $(this).val();

    var currentUrl = $(location).attr('href');
    var url = new URL(currentUrl);

    if (sortBy === "reverse") {
      url.searchParams.set("sort_by", sortBy);
    } else {
      url.searchParams.delete("sort_by");
    }

    var newUrl = url.href;
    window.location.href = newUrl;
  });



});


// window.onload = function() {
//   if ($('.globo-formbuilder').length > 0) {
//     var productName = $('.product-single__title').text();
//     $('#hidden').val(productName);
//   }
// }





